/** localStorage key for persisted demo ID (per browser). */
export const STORY_DEMO_ID_STORAGE_KEY = 'brighthub-demo-id';
